import { FormControl as MuiFormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const FormControl = styled(MuiFormControl)<{ iserrored?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: auto !important;
  position: unset;
  gap: ${theme.spacing.xSmall}px;

  &:hover {
    fieldset {
      border-color: ${theme.colors.cta} !important;
    }

    .MuiOutlinedInput-root {
      border-color: ${theme.colors.cta} !important;
    }
  }

  .helper-text {
    color: ${theme.baseColors.info[50]};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: normal;
    position: unset;

    &.error-text {
      color: ${theme.colors.errorLight};
    }
  }

  ${({ iserrored }) =>
    iserrored &&
    iserrored === 'true' &&
    `
      .MuiOutlinedInput-root {
        fieldset {
          border-color: ${theme.colors.cta} !important;
        }
      }
    `};

  fieldset {
    color: ${theme.colors.dropdownLabel};
    font-family: Quicksand, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    border: 1px solid ${theme.colors.dropdownBorder};
  }

  .MuiFormControl-root {
    width: 100%;
  }

  .MuiInputLabel-root {
    color: ${theme.colors.dropdownLabel} !important;
    font-family: Quicksand, sans-serif !important;
    font-size: 12px !important;
    font-style: normal !important;
    font-weight: 500 !important;
  }

  .MuiOutlinedInput-root {
    width: 100%;
    padding: 14px ${theme.spacing.small}px;
    border-radius: ${theme.attributes.borderRadius.tertiary};
    color: ${theme.colors.devicesSecondaryText};
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;

    &:hover {
      border-color: ${theme.colors.cta};
    }

    &.Mui-focused {
      padding: 14px ${theme.spacing.small}px !important;
      border-radius: ${theme.attributes.borderRadius.tertiary} !important;
      line-height: normal !important;
      font-family: ${theme.typography.fontFamily.primary} !important;
      font-weight: ${theme.typography.fontWeight.normal} !important;
      font-size: ${theme.typography.fontSize.large} !important;
      color: ${theme.colors.foreground} !important;
      background: transparent !important;

      fieldset {
        border: 1px solid ${theme.colors.cta} !important;
      }
    }

    &.Mui-disabled {
      color: ${theme.colors.foreground};
      -webkit-text-fill-color: ${theme.colors.foreground};

      .MuiOutlinedInput-input {
        &::placeholder {
          color: ${theme.baseColors.secondary[80]} !important;
          -webkit-text-fill-color: ${theme.baseColors.secondary[80]} !important;
          opacity: 1 !important;
        }
      }
    }

    .MuiOutlinedInput-input {
      width: 100%;
      //height: 48px;
      padding: 0;
      color: ${theme.colors.devicesSecondaryText};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;

      &::placeholder {
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-text-fill-color: ${theme.colors.devicesSecondaryText} !important;
        opacity: 1 !important;
        color: ${theme.colors.devicesSecondaryText};
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }

      &.Mui-disabled {
        color: ${theme.colors.foreground};
        -webkit-text-fill-color: ${theme.colors.foreground};
      }
    }

    .MuiInputAdornment-root {
      .MuiTypography-root {
        color: ${theme.baseColors.greyscale[50]} !important;
        font-family: ${theme.typography.fontFamily.primary} !important;
        font-size: ${theme.typography.fontSize.large} !important;
        font-style: normal !important;
        font-weight: ${theme.typography.fontWeight.bold} !important;
        line-height: 20px !important;
      }
    }
  }

  .char-counter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;

    .char-counter-text {
      color: ${theme.colors.dropdownLabel};
      font-family: Quicksand, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: right;

      &.text-danger {
        color: ${theme.colors.errorLight};
      }
    }
  }
`
